import styled from 'styled-components';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '@styles/index';

const BannerImage = styled.img`
  border-radius: ${Spacings.SPACE_2B};
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
`;

const GenericBanner = ({ block, itemWidth }) => {
  const data = block?.data[0];
  return (
    <a
      href={data.url}
      target={data.url.includes('http') ? '_blank' : '_self'}
      rel="noreferrer"
    >
      <BannerImage
        src={data.img}
        alt="banner"
        width={itemWidth || '848px'}
        height="265px"
      />
    </a>
  );
};

export default GenericBanner;

GenericBanner.propTypes = {
  block: PropTypes.objectOf(PropTypes.any).isRequired,
  itemWidth: PropTypes.string
};

GenericBanner.defaultProps = {
  itemWidth: '848px'
};
